import { Capacitor } from '@capacitor/core'

export const isNativePlatform = Capacitor.isNativePlatform()
export const nativePlatform = Capacitor.getPlatform()

export function getEnvValue(key: string): string {
  const envConfig = (window as Window & { ENV_CONFIG?: Record<string, string> }).ENV_CONFIG || {}
  return envConfig[key] || (import.meta.env[key] as string | undefined) || ''
}
